import comp from "./CategoryGradeScale";
export default comp;
